import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ICU from 'i18next-icu'
import translation_EN from './locales/en.json'

const resources = {
	en: {
		translation: translation_EN,
	},
}

i18n
	.use(ICU)
	.use(initReactI18next)
	.init({
		resources,
		debug: true,
		fallbackLng: 'en',
		lng: 'en',
	})

export default i18n
